/* Same pack-variant approach as the cleaning-cloth product: two colors and
   three pack sizes. Individual set colors and total liner counts are order properties. */
(()=>{
 function init(scope=document){
  for(const picker of scope.querySelectorAll('[data-fb-picker]')){
   const root=picker.closest('icp-product');if(!root?.ready||picker.ftReady)continue;
   picker.ftReady=true;
   const data=JSON.parse(picker.querySelector('[data-fb-config]').textContent);
   const configs=new Map(data.configs.map(c=>[c.key,c]));
   const configById=new Map(data.configs.map(c=>[c.id,c]));
   const variants=new Map(root.data.variants.map(v=>[v.id,v]));
   const state={count:3,colors:{1:[0],3:[0,0,0],5:[0,0,0,0,0]}};
   const deepLink=configById.get(Number(new URL(location.href).searchParams.get('variant')));
   if(deepLink){state.count=deepLink.count;state.colors[state.count]=deepLink.counts.flatMap((n,i)=>Array(n).fill(i));}
   const keyFor=colors=>colors.length+':'+colors[0];
   const configFor=colors=>configs.get(keyFor(colors));
   const set=(el,text)=>{if(el&&el.textContent!==text)el.textContent=text;};
   const selectedColor=picker.querySelector('[data-fb-selected-color]');
   function properties(config){
    const chosen=state.colors[state.count],counts=Array(data.colors.length).fill(0);chosen.forEach(i=>counts[i]++);
    const props={'Bundle':config.label,'Included sets':String(state.count),'Total liners':String(state.count*4),'Color breakdown':counts.map((n,i)=>n?data.colors[i].name+' × '+n:'').filter(Boolean).join(', ')};
    chosen.forEach((i,n)=>props['Set '+(n+1)+' color']=data.colors[i].name);

    root.form.querySelectorAll('[data-fb-property]').forEach(el=>el.remove());
    for(const [name,value]of Object.entries(props)){const input=document.createElement('input');input.type='hidden';input.name='properties['+name+']';input.value=value;input.dataset.fbProperty='';root.form.append(input);}
   }
   function sync(updateUrl=false,showImage=false){
    const config=configFor(state.colors[state.count]),variant=variants.get(config?.id);
    if(!variant){picker.querySelector('[data-fb-error]').textContent='This set is unavailable. Please choose another color.';return;}
    picker.querySelector('[data-fb-error]').textContent='';
    for(const [index,value]of variant.options.entries()){
     const group=picker.querySelector('[data-icp-option="'+(index+1)+'"]');
     group.querySelectorAll('input').forEach(input=>input.checked=input.value===value);
    }
    root.sync(false);root.form.querySelector('[name="quantity"]').value='1';properties(config);
    for(const card of picker.querySelectorAll('[data-fb-bundle]')){
     const count=+card.dataset.fbBundle,selected=count===state.count,cardConfig=configFor(state.colors[count]),cardVariant=variants.get(cardConfig?.id);
     card.dataset.selected=String(selected);card.querySelector('[data-fb-bundle-radio]').checked=selected;
     card.querySelector('[data-fb-unit-pickers]').hidden=!selected;
     const base=variants.get(configs.get('1:0')?.id)?.price||0,saving=Math.max(0,base*count-(cardVariant?.price||0));
     set(card.querySelector('[data-fb-tier-price]'),root.money(cardVariant?.price||0));
     set(card.querySelector('[data-fb-tier-caption]'),count===1?'1 set · 4 liners total':count+' sets · '+count*4+' liners · Save '+root.money(saving)+' vs buying separately');
     card.querySelectorAll('[data-fb-unit-color]').forEach(select=>{
      const i=+select.dataset.fbUnitColor,color=state.colors[count][i];select.value=String(color);
      const image=select.closest('.ft-unit').querySelector('img');if(image.src!==data.colors[color].image)image.src=data.colors[color].image;image.alt=data.colors[color].name+' set';
     });
    }
    const first=state.colors[state.count][0];set(selectedColor,data.colors[first].name);
    picker.querySelectorAll('[data-fb-color]').forEach(button=>button.setAttribute('aria-pressed',String(+button.dataset.fbColor===first)));
    if(showImage){const native=variants.get(configFor([first]).id);if(native?.media)root.showMedia(native.media);}
    if(updateUrl){const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);}
    picker.dataset.fbVariant=String(variant.id);
   }
   picker.addEventListener('click',event=>{
    const color=event.target.closest('[data-fb-color]');
    if(color){const i=+color.dataset.fbColor;for(const count of [1,3,5])state.colors[count]=Array(count).fill(i);sync(true,true);return;}
    const card=event.target.closest('[data-fb-bundle]');
    if(card&&!event.target.closest('select')){state.count=+card.dataset.fbBundle;sync(true);}
   });
   picker.addEventListener('change',event=>{
    if(event.target.matches('[data-fb-unit-color]')){const card=event.target.closest('[data-fb-bundle]');state.colors[+card.dataset.fbBundle][+event.target.dataset.fbUnitColor]=+event.target.value;sync(true,+event.target.dataset.fbUnitColor===0);}
    else if(event.target.matches('[data-fb-bundle-radio]')){state.count=+event.target.value;sync(true);}
   });
   const upsell=root.querySelector('[data-fb-upsell]');
   if(upsell){const select=upsell.querySelector('select'),check=upsell.querySelector('[data-icx-attach]');select.addEventListener('change',()=>{check.dataset.icxAttachId=select.value;});}
   root.addEventListener('submit',()=>{sync(false);},true);
   root.querySelector('[data-icp-buy]')?.addEventListener('click',()=>sync(false),true);
   sync(false);picker.dispatchEvent(new CustomEvent('ft:ready'));
  }
 }
 const boot=()=>{let attempts=0;const retry=()=>{init();if(document.querySelector('[data-fb-picker]:not([data-fb-variant])')&&attempts++<80)setTimeout(retry,100);};customElements.whenDefined('icp-product').then(retry);};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
 document.addEventListener('shopify:section:load',boot);
})();
